// extracted by mini-css-extract-plugin
module.exports = {"border":"DemoModeBorder_border__1tnil","tagWrapper":"DemoModeBorder_tagWrapper__qayH4","tag":"DemoModeBorder_tag__Hop00"};